export default [{
	path: '/nct',
	component: () => import('../../views/nct'),
	redirect: '/nct/category',
	children: [{
			path: 'category',
			component: () => import('../../views/nct/category')
		},
		{
			path: 'case',
			component: () => import('../../views/nct/case')
		}, {
			path: 'case2',
			component: () => import('../../views/nct/case2')
		},
		{
			path: 'webgl',
			component: () => import('../../views/nct/webgl')
		}, {
			path: 'viewResource',
			component: () => import('../../views/nct/viewResource')
		}
	]
}]